<div [class.d-flex]="hasAddon()">
  @if (prefix()) {
    <span
      class="form-control w-auto pointer-events-none prefix-text bg-transparent"
    >
      {{ prefix() | lowercase }}
    </span>
  }
  <input
    type="number"
    class="form-control"
    [ngClass]="{
      'prefix-input': prefix(),
      'suffix-input': suffix(),
    }"
    [min]="min()"
    [max]="max()"
    [step]="step()"
    [placeholder]="placeholder()"
    [value]="value()"
    (input)="onInput($any($event.target).value)"
  />
  @if (suffix()) {
    <span
      class="form-control w-auto pointer-events-none suffix-text bg-transparent"
    >
      {{ suffix() | lowercase }}
    </span>
  }
</div>
